import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 13.124 14.624"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.562 0A6.57 6.57 0 0 0 0 6.562c0 3.839 3.522 6.165 5.853 7.705l.397.263a.56.56 0 0 0 .624 0l.397-.263c2.331-1.54 5.853-3.866 5.853-7.705A6.57 6.57 0 0 0 6.562 0m.089 13.328-.089.059-.089-.059c-2.258-1.491-5.349-3.533-5.349-6.766a5.445 5.445 0 0 1 5.438-5.438A5.445 5.445 0 0 1 12 6.562c0 3.233-3.092 5.275-5.349 6.766m-.089-9.204a2.44 2.44 0 0 0-2.438 2.438A2.44 2.44 0 0 0 6.562 9 2.44 2.44 0 0 0 9 6.562a2.44 2.44 0 0 0-2.438-2.438m0 3.75a1.313 1.313 0 1 1 .002-2.626 1.313 1.313 0 0 1-.002 2.626"
    }, null, -1)
  ])))
}
export default { render: render }